<template>
    <div class="twoGame">
        <head-view></head-view>
        <div class="twoGameViewVue w"><!-- style="color: red;" -->
        <div class="title two" > <b>公司介绍：</b> 
            <p>实渲网络是一家充满创意与激情的初创应用研发公司，致力于打造高品质、多元化的应用体验。我们专注于创新玩法与精美视觉的融合，力求为全球玩家带来沉浸式的娱乐体验。
            </p>
            <p>在实渲网络，我们相信应用不仅是娱乐，更是一种情感表达与梦想实现的方式。团队成员皆为资深应用开发者与热爱应用的梦想家，涵盖策划、程序、美术等多个领域，共同探索应用世界的无限可能。
            </p>
            <p>我们坚持以玩家体验为核心，以技术创新为驱动，持续推出富有创意与深度的应用作品。无论是竞技、策略，还是冒险、休闲，我们都力求突破传统，创造令人耳目一新的应用体验。
            </p>
            <p>实现应用梦，点燃新世界！
            </p>
            <!-- <a href="">查看所有游戏></a> -->
             
        </div>
        <!-- <div class="text">Few Step For a New Home</div> -->
       <!--  <div class="process-img">
            <ul>
                <li>
                    <router-link to="/oneGameViewVue">
                        <img src="@/assets/img/20250213204801.png" alt="">
                    </router-link>
                    <p class="step">
                        <router-link to="/oneGameViewVue">塔防游戏</router-link> 
                    </p>
                </li>
                
            </ul>
        </div> -->
    </div>
    </div>
</template>
<script>
import headView from '../header/headView.vue'
export default {
  components: { headView },
}
</script>